import React from "react"
import { Link } from "gatsby"
import Image from "../components/image"
import MobileOnly from "../components/mobile-only"

function TextWithImage({
  title,
  stat,
  caption,
  image,
  target,
  children,
  classes,
}) {
  return (
    <section
      className={classes ? `text-with-image ${classes}` : `text-with-image`}
    >
      <div className="text-with-image__image">
        <Image path={image} />
      </div>
      <div className="text-with-image__text">
        <header>
          <Link className="text-with-image__text__title" to={target}>
            {title}
          </Link>
          <p className="text-with-image__text__stat">{stat}</p>
          {caption ? (
            <p className="text-with-image__text__caption">{caption}</p>
          ) : null}
        </header>
        <MobileOnly>
          <div className="text-with-image__text__image">
            <Image path={image} />
          </div>
        </MobileOnly>
        {children}
        <Link
          className="cta cta--secondary text-with-image__text__link"
          to={target}
        >
          Go to {title}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="https://www.w3.org/2000/svg"
          >
            <path
              d="M15.0378 6.34317L13.6269 7.76069L16.8972 11.0157L3.29211 11.0293L3.29413 13.0293L16.8619 13.0157L13.6467 16.2459L15.0643 17.6568L20.7079 11.9868L15.0378 6.34317Z"
              fill="currentColor"
            />
          </svg>
        </Link>
      </div>
    </section>
  )
}

export default TextWithImage
